/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
// import { Dimensions } from 'react-native';
import { t } from 'i18next';

import "./ShuttleTableTab.css";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const ShuttleTable1 = () => {    
    return(
        <div className="sect-01-box-01-hotel">
            <div className='shuttle-table-title'>
                <h4>
                    <span>
                        {t("shuttle_map_toward_UECO")}
                    </span>
                </h4>
            </div>
            <div className='text-center'>
            <div className='shuttle-table w-full md:w-3/4 max-w-6xl'>
                <table>
                    <colgroup>
                        <col width = "19%"/>
                        <col width = "19%"/>
                        <col width = "19%"/>
                        <col width = "19%"/>
                        <col width = "19%"/>
                    </colgroup>
                    <tbody>
                        <tr class="first">
                            <td></td>
                            <td>{t("shuttle_UU")}</td>
                            <td>{t("shuttle_UNIST")}</td>
                            <td>{t("shuttle_KTX")}</td>
                            <td class="last">{t("shuttle_UECO")}</td>
                        </tr>
                        <tr class="rose">
                            <td>{t("shuttle_car1")}</td>
                            <td>09:00</td>
                            <td>09:20</td>
                            <td>09:30</td>
                            <td class="last">09:35</td>
                        </tr>
                        <tr class="purple">
                            <td>{t("shuttle_car2")}</td>
                            <td>09:30</td>
                            <td>09:50</td>
                            <td>09:55</td>
                            <td class="last">10:00</td>
                        </tr>
                        <tr class="rose">
                            <td>{t("shuttle_car1")}</td>
                            <td>11:00</td>
                            <td>11:20</td>
                            <td>11:30</td>
                            <td class="last">11:35</td>
                        </tr>
                        <tr class="purple">
                            <td>{t("shuttle_car2")}</td>
                            <td>11:30</td>
                            <td>11:50</td>
                            <td>12:00</td>
                            <td class="last">12:05</td>
                        </tr>
                        <tr class="rose">
                            <td>{t("shuttle_car1")}</td>
                            <td>13:30</td>
                            <td>13:50</td>
                            <td>14:00</td>
                            <td class="last">14:05</td>
                        </tr>
                        <tr class="purple">
                            <td>{t("shuttle_car2")}</td>
                            <td>14:00</td>
                            <td>14:20</td>
                            <td>14:30</td>
                            <td class="last">14:35</td>
                        </tr>
                        <tr class="rose">
                            <td>{t("shuttle_car1")}</td>
                            <td>15:30</td>
                            <td>15:50</td>
                            <td>16:00</td>
                            <td class="last">16:05</td>
                        </tr>
                        <tr class="purple">
                            <td>{t("shuttle_car2")}</td>
                            <td>16:00</td>
                            <td>16:20</td>
                            <td>16:30</td>
                            <td class="last">16:35</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
            
        </div>
    )
}

export default ShuttleTable1;